import { render, staticRenderFns } from "./MarkComponent.vue?vue&type=template&id=ab9a37f2&"
import script from "./MarkComponent.vue?vue&type=script&lang=js&"
export * from "./MarkComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarkComponent.vue?vue&type=style&index=0&id=ab9a37f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports